module.exports = __webpack_public_path__ + "static/media/Mo.50142ac3.jpg";